import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import type { Profile, PaginationMeta, SearchResponse } from "./types";

interface UseProfilesSearchResult {
  data: Profile[];
  meta: PaginationMeta | null;
  isLoading: boolean;
  error: Error | null;
}

export function useProfilesSearch(
  searchUrl: string,
  query: string,
  page: number,
): UseProfilesSearchResult {
  const { data, isLoading, error } = useQuery<SearchResponse, Error>({
    queryKey: ["profiles", searchUrl, query, page],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (query) params.set("q", query);
      params.set("page", String(page));

      const url = `${searchUrl}?${params.toString()}`;
      const response = await axios.get<SearchResponse>(url, {
        headers: { Accept: "application/json" },
      });

      return response.data;
    },
  });

  // Handle both array response and { data, meta } response
  const profiles = Array.isArray(data) ? data : (data?.data ?? []);
  const meta = Array.isArray(data) ? null : (data?.meta ?? null);

  return {
    data: profiles,
    meta,
    isLoading,
    error: error ?? null,
  };
}
